import {FunctionComponent, PropsWithChildren} from 'react';

export const PortfolioNoContentContainer: FunctionComponent<PropsWithChildren<{}>> = ({children}) => {
  return (
    <div className='w-full h-full bg-graybluedark2 rounded-2xl flex-center min-h-loadingEmptyTile'>{children}</div>
  );
};
